import React from "react";
import { Link, useInRouterContext } from "react-router-dom";

// Foutgrens. Twee plekken:
//  - rond de hele app (app/Providers.jsx), buiten de router: laatste vangnet;
//  - rond elke route (App.jsx) met `resetKey` = het pad: een crash raakt dan alleen het
//    inhoudsgebied, zijbalk en topbar blijven werken, en naar een andere pagina gaan
//    herstelt de grens vanzelf.
function ErrorFallback({ onRetry }) {
  // Buiten de router (de app-brede grens) kan er geen <Link> staan.
  const inRouter = useInRouterContext();
  return (
    <div className="route-error" role="alert">
      <h2 className="route-error__title">Er ging iets mis</h2>
      <p className="route-error__text">Deze pagina kon niet getoond worden. Probeer het opnieuw of ga terug naar het overzicht.</p>
      <div className="route-error__actions">
        <button type="button" className="route-error__retry" onClick={onRetry}>
          Opnieuw proberen
        </button>
        {inRouter ? (
          <Link to="/" className="route-error__link">
            Naar Overzicht
          </Link>
        ) : (
          <a href="/" className="route-error__link">
            Naar Overzicht
          </a>
        )}
      </div>
    </div>
  );
}

export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
    this.reset = this.reset.bind(this);
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, info) {
    console.error("UI error:", error, info);
  }

  componentDidUpdate(prevProps) {
    // Andere route → opnieuw proberen met de nieuwe inhoud.
    if (this.state.hasError && prevProps.resetKey !== this.props.resetKey) {
      this.reset();
    }
  }

  reset() {
    this.setState({ hasError: false, error: null });
  }

  render() {
    if (this.state.hasError) {
      // De app-brede grens (zonder resetKey) herlaadt de pagina, zoals voorheen: daar
      // is de shell zelf gecrasht. Een routegrens probeert alleen de inhoud opnieuw.
      const onRetry = "resetKey" in this.props ? this.reset : () => window.location.reload();
      return <ErrorFallback onRetry={onRetry} />;
    }
    return this.props.children;
  }
}
